<template>
	<div class="borderBox outpatientBox" style="background-color: #FFF;height: 100%;">
		<div class="borderBox display-f outpatientTop" style="height: 56px;padding: 12px 16px;">
			<custom-input class="mr10 searchInput" v-model="searchValue" prefix-icon="el-icon-search" clearable
				@input="changeList()" placeholder="搜索姓名/手机号"></custom-input>
			<custom-button class="outpatientQuick" type="primary" size="medium" plain @click="fastPrescription()">快捷开方</custom-button>
		</div>
		<div class="outpatientList">
			<div v-if="isHelper && helpDoctorList.length > 0" class="helperBox borderBottomEBE">
				<el-select ref="selectPatient" v-model="helpDoctorId" @change="helpDoctorChange"
					:popper-append-to-body="false" popper-class="customSelectStyle">
					<el-option value="none" disabled>
						<span class="color6671 size12">助理的医生</span>
					</el-option>
					<el-option v-for="item in helpDoctorList" class="option-item" :key="item.doctorId"
						:label="item.doctorName" :value="item.doctorId">
					</el-option>
				</el-select>
			</div>
			<div class="borderBottomEBE display-f align-i-c just-b " style="height: 35px;">
				<div class="display-f align-i-c">
					<div
						v-for="item in tabsList"
						:key="item.id"
						v-if="tabIsShow(item)"
						class="display-f align-i-c ml16 tabsBox"
						:class="activeName == item.id ? 'tabsBorder' : ''"
						style="height: 35px;"
						@click="changeList(item.id)">
						<div v-if="item.number == 0" class="size14 color0000 mr2 pointer font600">{{ item.label }}</div>
						<el-badge v-else class="item " :value="item.number">
							<div class="size14 color1F2 mr2 pointer font500">{{ item.label }}</div>
						</el-badge>
					</div>
				</div>
				<!-- <el-date-picker v-show="activeName === 1" class="dateTime " style="width:80px;" :clearable="false" v-model="timeSearch" prefix-icon="e"
					@change="changeList()" format="MM-dd" type="date" value-format="yyyy-MM-dd"
					:picker-options="pickerOptions" placeholder="选择日期">
				</el-date-picker> -->
			</div>
			<div v-if="activeName === 2 && ['0', '1'].includes(userType)" class="online_status">
				<el-dropdown class="online_status_dropdown" trigger="click" placement="bottom" @command="onlineStatusChange">
					<div :class="{ online_status_btn: true, online: doctorIsOnline === 1, offline: doctorIsOnline === 0 }">
						<span class="online_status_btn_text">{{ doctorIsOnline === 1 ? '在线' : '离线' }}</span>
						<span class="el-icon-caret-bottom online_status_btn_icon"></span>
					</div>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item :command="1">在线</el-dropdown-item>
						<el-dropdown-item :command="0">离线</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
      <div class="date-picker" v-show="activeName === 1">
        <el-date-picker value-format="yyyy-MM-dd" class="dateTime " :clearable="false" v-model="timeSearch" prefix-icon="e"
					@change="changeList()" type="daterange" placeholder="选择日期">
				</el-date-picker>
      </div>
			<div class="listStyle size14 scroll-loadmore" v-loadMore="getMoreList" id="outPatientBox">
				<div v-if="showSearch" class="borderEBE display-f align-i-c just-c size14 color667"
					style="height: 30px;">
					搜索到<span class="color1F2 font500 mr2 ml2">{{ searchTotal }}</span>条信息</div>
				<div class="h100_ display-f align-i-c just-c color667" v-if="(activeName == 1 && $lodash.isEmpty(outlineList)) || (activeName == 2 && $lodash.isEmpty(onlineList))">{{ activeName === 1 ? '暂无门诊记录' : '暂无网诊记录' }}</div>
				<div v-for="item in (activeName == 1 ? outlineList : onlineList)"
					:key="activeName == 1 ? item.orderId : item.webChatOrderInfoId" @click="choosePatient(item)"
					class="patientBox pointer display-f align-i-c just-b borderBox mt8 color0000"
					:class="(activeName == 1 ? item.orderId == choosePatientInfo.orderId : item.webChatOrderInfoId == choosePatientInfo.webChatOrderInfoId) ? 'choosePatient' : ''">
					<div class="display-f align-i-c">
						<div class="mr4 border2" style="background-color: #fff;">
							<span class="iconfont icon-yonghu size14"
								:class="(activeName == 2 ? item.sex == 1 : item.sex == 1) ? 'colorFF3' : 'color189'"></span>
						</div>
						<el-badge v-if="activeName == 2 && item.unreadMessage > 0" is-dot class="item">{{
							item.patientName
							}}</el-badge>
						<span v-else class="text-overflow size14 font500">
							{{ item.patientName ? item.patientName : '匿名患者' }}
							<span v-if="item.isGroupOrder && item.groupOrderPlat === 1">(美团)</span>
						</span>
						<span v-if="item.transferFlag" class="ml6 size13 color949" :class="(activeName == 1 ? item.orderId == choosePatientInfo.orderId : item.webChatOrderInfoId == choosePatientInfo.webChatOrderInfoId) ? 'colorfff' : ''">转方</span>
						<span v-if="item.referralStatus" class="order_tag">转诊</span>
					</div>
					<div class="font500 size12">
						<span class="mr16" v-if="item.preExamineFlag == 1">已预诊</span>
						<span v-if="activeName === 2 && ['-2', '3', '4'].includes(item.status)" class="list_payOrderStatus" :style="`color: ${payOrderStatusMap[item.orderStatus] && payOrderStatusMap[item.orderStatus].color || '#A4AFBA'};`">{{ payOrderStatusMap[item.orderStatus] && payOrderStatusMap[item.orderStatus].label }}</span>
						<span
							v-if="activeName == 1 && (timeFormatMM(item.updateDate) == timeFormatMM(systemTime))">
							<span v-if="['2', '3'].includes(item.registerType)">[特约]</span>
							<span v-if="['5', '7'].includes(item.registerType)">[回馈]</span>
							{{ item.type ? getType(item.type) : timeFormatMM(item.updateDate) }}
							{{ item.orderScheduleNum || '' }}
						</span>
						<span v-else>{{ item.payTime ? $moment(item.payTime).format('MM-DD') : timeFormatMM(item.updateDate) }}</span>
						<span class="ml24 size12 tag-section" :class="getStatus(item.status).tag">{{ getStatus(item.status).name }}</span>
					</div>
				</div>
			</div>
			<div style="height: 180px;">

				<div class="borderEBE borderBox size14 color1F2 font500" style="padding: 8px 16px;">
					<!-- 小工具 -->
					<span class="pointer color0000 size14 font600">小工具</span>

				</div>
				<div class=" borderBox size14 color1F2 font500">
					<!-- 叫号 -->
					<el-popover placement="right-end" trigger="click" width="360" @show="openCallNum"
						ref="callNumPopover">
						<callNum-dialog ref="callNumRef" :title="title" :callNumObj="callNumObj"
							@closeCallNum="closeCallNum" @callNum="callNum"></callNum-dialog>
						<div slot="reference" class="pointer display-f align-i-c just-b utilBox">
							<div class="display-f align-i-c "><img :src="imgArr.callNum"
									class="toolIcon"><span>叫号</span></div>
							<div class="display-f align-i-c color9AA0 size14"><span>下一位</span><i
									class="el-icon-arrow-right"></i></div>
						</div>
					</el-popover>
					<!-- 数据看板 -->
					<div v-if="isDoctorOrDoctorAssistant" @click="openDataBoard" class="pointer display-f align-i-c just-b utilBox">
						<div class="display-f align-i-c "><img :src="imgArr.dataBoardNew"
								class="toolIcon size12"><span>数据看板</span></div>
						<div class="display-f align-i-c color9AA0 size12"><span>医生工作汇总</span><i
								class="el-icon-arrow-right"></i></div>
					</div>
					<!-- <el-popover placement="top-start" width="150" trigger="hover" content="正在开发，敬请期待~">
						<div slot="reference" class="pointer display-f align-i-c just-b utilBox">
							<div class="display-f align-i-c "><img src="@/assets/images/dataBoard.png"
									class="toolIcon"><span>数据看板</span></div>
							<div class="display-f align-i-c color9AA0 size14"><span>医生工作汇总</span><i
									class="el-icon-arrow-right"></i></div>
						</div>
					</el-popover> -->

				</div>
			</div>
		</div>
		<!-- 弹框 -->
		<div>
			<div v-for="item in levelData" :key="item.name">
				<div v-if="visibleObj[item.name]">
					<component :is="item.dialog" v-if="visibleObj[item.name]" :ref="item.ref" :visibleObj="visibleObj"
						@close="dialogVisible" @updateData="confirmUpdateData" :dialogObj="dialogObj"></component>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { webChatList, webChatNum, switchDoctorOnLine } from "@/api/webchat"; // 网诊请求
import { Patient, Common } from "../data/index.js";
import { onlineStatus, outpatientStatus, schedulingTypeList } from '@/utils/const.js';
import CustomInput from '@/components/CustomInput.vue'
import { Utils } from '@/utils/utils'
import { levelData, visibleObj } from '@/components/js/dialog'
import dataDoardDialog from '../component/dataDoardDialog';
import callNumDialog from "../component/callNumDialog.vue";
import { doctorDTO, CommonDTO } from '@/DTO/index.js'
import { imgArr } from "@/assets/images/img.js";
export default {
	components: {
		CustomInput, dataDoardDialog, callNumDialog
	},
	props: {
		doctorInfo: { type: Object, default: () => { return {} } }
	},
	data() {
		return {
			imgArr: imgArr,
			isDoctorOrDoctorAssistant: false, // 是否是医生或医助
			isMore: false,//是否在加载更多
			searchValue: null,
			activeName: 1,
			tabsList: [
				{ id: 1, label: '门诊', number: 0 },
				{ id: 2, label: '在线咨询', number: 0 }
			],
			payOrderStatusMap: {
				'-7': { label: '已退', color: '#F54A45' },
				'3': { label: '已诊', color: '#A4AFBA' },
				'4': { label: '已收', color: '#A4AFBA' },
				'8': { label: '待收', color: '#FE8F1F' },
				'9': { label: '关闭', color: '#A4AFBA' }
			},
			timeSearch: [],//时间选择
			choosePatientInfo: {},//选择的患者id
			doctorId: null, // 医生id或医助id
			doctorUserCode: '', // 医生或医助userCode
			helpDoctorInfo: {},
			deptId: this.$session.get('deptId'),
			onlineSearchForm: {//网诊
				pageNum: 1,
				pageSize: 20,
			},
			outLineSearchForm: {//门诊
				currentPage: 1,
				pageSize: 20,
				searchSource: '0',
				orderTypes: ["0"],//0-门诊就诊，4-零售开单，5-网诊就诊，12-续方就诊
			},
			onlineList: [],//网诊列表
			outlineList: [],//门诊列表
			onlineTotalPage: 0,//网诊总页数
			hasMoreList: false,//是否有更多列表
			onlineStatus: onlineStatus,//网诊在线状态
			outpatientStatus: outpatientStatus,//门诊患者状态
			showSearch: false,//展示搜索多少条
			searchTotal: 0,//搜索总条目
			outlineTotalPage: 0,//门诊总页数
			schedulingTypeList: schedulingTypeList,//挂号时间状态
			outLineInterVal: null,
			onLineInterVal: null,

			levelData: levelData,
			visibleObj: visibleObj,
			currentLevelData: {},//显示在最上面弹框对象信息
			dialogObj: {},//弹框数据
			title: this.$session.get("user").nickName,
			callNumObj: {},
			showCallNum: false,
			assistantId: null,//助理id
			helpDoctorId: null,//选择助理的医生id
			isHelper: false,//是否是助理
			helpDoctorList: [],//助理医生列表
			systemTime: null,
			isLoadMore: true,//是否加载下一页

		}
	},
	// this.initFun()
	async created() {
		let time = await this.getSysTime();
		
		this.systemTime = this.$moment(time).valueOf()
		this.timeSearch = [this.$moment(time).format('YYYY-MM-DD'), this.$moment(time).format('YYYY-MM-DD')]
		this.getUserType()

		// 判断是否是医生或医助
		const { type } = this.$session.get('user')
		if (['0', '1'].includes(type)) {
		  this.isDoctorOrDoctorAssistant = true
		}

		if (this.outLineInterVal) {
			clearInterval(this.outLineInterVal)
		}
		this.outLineInterVal = setInterval(() => {
			this.getOutpatientNum()
			this.getOutlineList(2)
		}, 60000)

	},
	beforeDestroy() {
		clearInterval(this.outLineInterVal)
	},
	computed: {
		getStatus() {
			let that = this;
			return function (status) {
				if (that.activeName == 1) {
					return that.outpatientStatus.filter(val => val.id == status)[0] || {}
				} else {
					return that.onlineStatus.filter(val => val.id == status)[0] || {}
				}
			}
		},
		getType() {
			let that = this;
			return function (type) {
				return that.schedulingTypeList.filter(val => val.value == type)[0].label
			}
		},
		timeFormatMM() {
			let that = this;
			return function (time) {
				return that.$moment(time).format('MM-DD')
			}
		},
		pickerOptions() {
			let that = this;
			return {
				disabledDate(time) {
					return time.getTime() > that.systemTime || time.getTime() < (that.systemTime - 365 * 24 * 3600 * 1000);
				}

			}
		},
		doctorIsOnline() {
			let status = 1
			if (this.isHelper) {
				status = this.helpDoctorInfo.isOnLine
			} else {
				status = this.doctorInfo.isOnLine
			}
			return status
		},
		tabIsShow () {
			return (tab) => {
				let show = false
				switch (tab.id) {
					case 1:
						show = true
						break
					case 2:
						show = true
						break
					default:
						show = true
				}
				return show
			}
		}
	},
	methods: {
		async getSysTime() {
			let res = CommonDTO.getSystemTimeDTO()
			return new Date(res)
		},
		initFun() {
			// this.getOnlineWaitNum()
			if (this.activeName === 1) {
				this.getOutlineList(1)
				this.getOutpatientNum()
			} else {
				this.getOnlineList(1)
			}
		},
		//获取当前用户登录角色
		getUserType() {
			let type = this.$session.get("user").type
			let userId = this.$session.get("user").userId
			this.userType = type
			if (type == '1') {
			  // 医助
				this.isHelper = true;
				this.assistantId = userId;
				this.getHelpDoctor()
			} else {
			  // 医生
				this.isHelper = false;
				this.assistantId = null;
				this.doctorId = this.$session.get("user").hospDoctorInfo.doctorId
				this.doctorUserCode = this.$session.get("user").userCode
				this.initFun()
			}
		},
		//获取助理医生
		async getHelpDoctor() {
			let obj = {
				deptId: this.deptId,
				helperId: this.assistantId
			}
			let { code, data } = await doctorDTO.getHelpDoctorListDTO(obj);
			if (code == 200) {
				if (!_.isEmpty(data)) {
					this.helpDoctorList = data
					let flagArr = data.filter(val => val.lastHelpFlag == 1)
					if (!_.isEmpty(flagArr)) {
						this.helpDoctorId = flagArr[0].doctorId
						this.doctorId = flagArr[0].doctorId
					} else {
						this.helpDoctorId = data[0].doctorId
						this.doctorId = data[0].doctorId
						this.markDoctor()
					}
					this.setHelpDoctorInfo()
					this.initFun()
				}
			}
		},
		//医助变化助理医生
		helpDoctorChange(e) {
			if (e == 'none') {
				return false
			}
			this.doctorId = this.helpDoctorId;
			this.setHelpDoctorInfo()
			this.markDoctor()
			this.initFun()
		},

		// 设置医助doctorUserCode
		setHelpDoctorInfo() {
		  const helpDoctorInfo = this.helpDoctorList.find(item => item.doctorId == this.helpDoctorId) || {}
		  this.doctorUserCode = helpDoctorInfo.userCode || ''
			this.helpDoctorInfo = helpDoctorInfo
		},
		
		//标记助理医生
		async markDoctor() {
			let obj = {
				deptId: this.deptId,
				helperId: this.assistantId,
				doctorId: this.doctorId
			}
			let res = await doctorDTO.markDoctorDTO(obj)

		},
		changeList: _.debounce(function (id) {
			if (id) {
				this.activeName = id
				this.$emit('consultationTypeChange', id)
			}

			clearInterval(this.outLineInterVal)
			clearInterval(this.onLineInterVal)

			this.clearListInfo()
			if (this.activeName == 1) {
				this.getOutlineList(1)
				this.getOutpatientNum()

				this.outLineInterVal = setInterval(() => {
					this.getOutpatientNum()
					this.getOutlineList(2)
				}, 60000)
			} else {
				this.getOnlineList(1)

				this.onLineInterVal = setInterval(() => {
					this.getOnlineList(2)
				}, 60000)
			}
		}, 300),
		clearListInfo() {
			this.hasMoreList = false;
			this.onlineSearchForm.pageNum = 1;
			this.outLineSearchForm.currentPage = 1;
			this.onlineList = [];

		},
		//获取门诊列表
		// getOutlineList: _.debounce(async function (num) {
		async getOutlineList(num) {
			// if (this.outLineInterVal) {
			//     clearInterval(this.outLineInterVal)
			// }
			if (num) {
				this.clearListInfo()
			} else {
				// this.searchValue = null
			}

			let lastYear = this.$moment().subtract(1, 'years')
			let obj = {
				...this.outLineSearchForm,
				...!!this.searchValue && {
				  searchSource: '5'
				},
				doctorId: this.doctorId,
				searchValue: this.searchValue,
				deptId: this.deptId,
				// startDate: (this.searchValue && this.searchValue != '') ? Common.startOfDay(lastYear) : Common.startOfDay(this.timeSearch[0]),
				// endDate: (this.searchValue && this.searchValue != '') ? Common.endOfDay(this.$moment()) : Common.endOfDay(this.timeSearch[1]),
			}
      if(this.searchValue && this.searchValue != '' && this.timeSearch[0] == this.$moment().format('YYYY-MM-DD')){
        obj.startDate = Common.startOfDay(lastYear)
        obj.endDate = Common.endOfDay(this.$moment())
      }else{
        obj.startDate = Common.startOfDay(this.timeSearch[0])
        obj.endDate = Common.endOfDay(this.timeSearch[1])
      }
			let { data } = await Patient.getOutPatientList(obj)
			if (num && (this.outLineSearchForm.currentPage == 1)) {
				this.outlineList = data
			} else {
				this.outlineList = this.outlineList.concat(data);
			}
			if (!_.isEmpty(this.outlineList) && num && num != 2) {
				this.choosePatient(this.outlineList[0])
			}
			if (_.isEmpty(this.outlineList)) {
				this.$emit('clearInfo')

			}
			this.isLoadMore = Utils.lt(data.length, this.outLineSearchForm.pageSize) ? false : true
			this.isMore = false
			if (data.length >= this.outLineSearchForm.pageSize) {
				this.hasMoreList = true
			} else {
				this.hasMoreList = false
			}
			// this.outLineInterVal = setInterval(() => {
			//     this.getOutpatientNum()
			//     this.getOutlineList(2)
			// }, 60000)
		},
		// }, 300),
		//获取门诊待诊数量
		getOutpatientNum() {
			// let obj = {
			//     doctorId: this.doctorId,
			//     deptId: this.deptId,
			//     startDate: Common.startOfDay(this.timeSearch),
			//     endDate: Common.endOfDay(this.timeSearch),
			// }
			// Patient.getOutpatientNum(obj).then(res => {
			//     this.tabsList[0].number = res.data
			// })
		},
		//获取网诊列表
		getOnlineList(num) {
			if (num) {
				this.clearListInfo()
			} else {}
			let obj = {
				pageNum: 1,
				pageSize: this.onlineSearchForm.pageNum * this.onlineSearchForm.pageSize,
				doctorId: this.doctorId,
				searchValue: this.searchValue
			}
			webChatList(obj).then(res => {
				if (res.code == 200) {
					this.isMore = false
					if (this.searchValue) {
						this.showSearch = true
						this.searchTotal = res.total
					} else {
						this.showSearch = false
					}
					this.onlineList = res.rows
					this.onlineTotalPage = Math.ceil(res.total / this.onlineSearchForm.pageSize)

					if (!_.isEmpty(this.onlineList) && num && num != 2) {
						this.choosePatient(this.onlineList[0])
					}
					if (_.isEmpty(this.onlineList)) {
						this.$emit('clearInfo')
					}

					if (res.rows.length >= this.onlineSearchForm.pageNum * this.onlineSearchForm.pageSize) {
						this.hasMoreList = true
					} else {
						this.hasMoreList = false
					}
					// this.listenerListBox()
				}
			})
		},
		//获取网诊待诊和正在就诊数量
		getOnlineWaitNum() {
			let obj = {
				...this.onlineSearchForm, doctorId: this.doctorId
			}
			webChatNum(obj).then(res => {
				if (res.code == 200) {
					this.tabsList[1].number = res.data.prePaidNum + res.data.visitingNum
				}
			})
		},
		getMoreList() {
			let that = this;
			// 加载下一页数据的逻辑
			if (this.activeName == 1) {
				// if (that.hasMoreList && that.outLineSearchForm.currentPage < that.outlineTotalPage) {
				//     that.outLineSearchForm.currentPage += 1
				//     that.getOutlineList()
				// }
				if (this.isLoadMore && !this.isMore) {
					that.isMore = true
					that.outLineSearchForm.currentPage += 1
					that.getOutlineList()
				}
			} else {
				if (that.hasMoreList && that.onlineSearchForm.pageNum < that.onlineTotalPage && !this.isMore) {
					that.isMore = true
					that.onlineSearchForm.pageNum += 1
					that.getOnlineList()
				}
			}


		},
		//快捷开方
		async fastPrescription(initInfo) {
      let time = await this.getSysTime()
			this.timeSearch = [this.$moment(time).format('YYYY-MM-DD'), this.$moment(time).format('YYYY-MM-DD')]
			this.activeName = 1
			this.$emit('consultationTypeChange', 1)
			let info = initInfo || { orderType: "0", deptId: this.deptId, doctorId: this.doctorId }
			Patient.quickPrescription(info).then(res => {
				this.getOutlineList(1)
			})
		},
		//选择患者
		choosePatient(row) {
			this.$parent.$parent.loading=true
			this.choosePatientInfo = row
			Patient.getPatientInfo({ orderId: row.orderId }).then(res => {
				let data = res.data
				data.order['webChatOrderInfoId'] = row.webChatOrderInfoId
				this.$emit('choosePatient', data)
			})
		},
		/**
		* 关闭弹框
		*/
		dialogVisible(name, bol) {
			let visibleObj = this.visibleObj;
			name = name || this.currentLevelData.name;
			visibleObj[name] = bol != undefined ? bol : !visibleObj[name];
			this.$set(this, "visibleObj", visibleObj);
			this.setDialogLevel(name)
			this.getLevelData(name);
		},
		/**
		 * 弹框确认
		 */
		confirmUpdateData(data) {
			let currentLevelData = this.currentLevelData;
			currentLevelData.confirmfn && this[currentLevelData.confirmfn](data);
		},
		// 设置弹窗层级
		setDialogLevel(currentLevel) {
			let visibleObj = this.visibleObj;
			let levelData = this.levelData;
			let that = this;
			if (this.visibleObj[currentLevel]) {
				levelData.map(v => {
					// 设置当前层的level为1，其余visible为true的level依次递增
					// enter confirm操作的始终是level为1的dialog
					if (v.name == currentLevel) {
						v.level = 1
					} else if (that.visibleObj[v.name]) {
						v.level = Utils.bigNumber(v.level, '+', 1)
					}
				})
			} else {
				levelData.map(v => {
					// 当前dialog关闭，则设置level为0， 其余visible为true的level依次减一
					if (v.name == currentLevel) {
						v.level = 0
					} else if (that.visibleObj[v.name] && Utils.gt(v.level, 0)) {
						v.level = Utils.bigNumber(v.level, '-', 1)
					}
				})
			}

			this.$set(this, 'levelData', levelData)
		},
		// 获取当前层级 及其Data
		getLevelData(name) {
			let visibleObj = this.visibleObj;
			let levelData = this.levelData;
			let obj = {};
			let currentLevelData = levelData.filter(v => {
				return v.level == 1
			});
			obj = {
				...currentLevelData[0],
			}
			this.$set(this, 'visibleObj', visibleObj)
			this.$set(this, 'currentLevelData', obj)
		},
		/**
		 * 打开数据看板
		 */
		openDataBoard() {
			// this.dialogObj.doctorId = this.doctorId || ''
			// this.dialogObj.doctorUserCode = this.doctorUserCode || ''
			// this.dialogVisible('dataDoardDialog', true)
      // 2026-06-18 改为直接跳转到医生数据
      this.$router.push('/doctorDataAnalysis')
		},
		openCallNum() {
			this.callNumObj = {
				deptId: this.deptId,
				doctorId: this.doctorId,
				date: this.timeSearch
			}
			this.showCallNum = true
			console.log(this.$refs.callNumRef);
			this.$nextTick(() => {
				this.$refs.callNumRef.init()
			})
		},
		closeCallNum() {
			this.$refs.callNumPopover.doClose()
		},
		callNum(data){
			this.choosePatient({orderId:data})
		},
		async onlineStatusChange (val) {
			const res = await switchDoctorOnLine({
				doctorId: this.doctorId,
				isOnLine: val
			})
			if (res.code === 200) {
				if (this.isHelper) {
					this.helpDoctorInfo.isOnLine = res.data.isOnLine
				} else {
					this.doctorInfo.isOnLine = res.data.isOnLine
				}
			}
		}
	}
}
</script>

<style lang="less" scoped>
@borderColor:#E0E0E0;
.outpatientBox {
	display: flex;
	flex-direction: column;
.outpatientTop{
	border:1px solid  @borderColor;
	border-radius: 2px 0 0 0;
}
	.outpatientList {
		flex: 1;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		border-left:1px solid @borderColor;
		border-right:1px solid @borderColor;
		border-bottom:1px solid @borderColor;
	}
}

.listStyle {
	flex: 1;
	padding: 0px 2px 8px 8px;
	box-sizing: border-box;
	overflow-y: auto;

	&::-webkit-scrollbar {
		width: 6px;
		background-color: #F5F5F5;
	}

	&::-webkit-scrollbar-thumb {
		border-radius: 12px;
		background-color: #CBCBCB;
	}
	.choosePatient {
		height: 40px;
		border-radius: 4px;
		// color: #1F2329;
		padding: 8px;
		font-size: 12px;
		// background-color: #1890FF;
		background-color: #40acff;
		color: #fff !important;
		.tag-section{
			color:#fff
		}
	}
	.tag-section {
		display: inline-block;
		width: 36px;
	}
	.patientBox:not(.choosePatient) {
		height: 40px;
		border-radius: 4px;
		// color: #1F2329;
		padding: 8px;
		font-size: 12px;
		&:hover {
			color: #1F2329;
			background-color: #F0F1F3;
		}
	}

   
}

/deep/.tabsBox .el-badge__content,
.tabsBox .el-progress.is-exception .el-progress-bar__inner {
	background-color: transparent;
	color: #F54A45;
	border: none;
}

/deep/.el-input--suffix .el-input__inner {
	padding-right: 16px;
}

/deep/.dateTime .el-input__inner {
	font-size: 12px;
	border: none;
	background-color: transparent;
}

.tabsBorder {
	border-bottom: 2px solid #1890FF;
}

.borderEBE {
	border-top: 1px solid @borderColor;
	border-bottom: 1px solid @borderColor;
}

.borderBottomEBE {

	border-bottom: 1px solid  @borderColor;
}

.toolIcon {
	height: 24px;
	width: 24px;
	margin-right: 8px;
}

.searchInput {
	/deep/.el-input__inner {
		border:1px solid #D3D3D5;
		border-radius: 4px;
	}

}
.outpatientQuick{
	width: 80px;
	border-radius: 4px;
}

.utilBox {
	padding: 12px 16px;
}

.helperBox> {

	/deep/.el-input__inner {
		width: 100px;
		border: 1px solid transparent;
		background: #FAFBFC;

	}
}

.online_status {
	width: 100%;
	height: 30px;
}

.online_status_dropdown {
	width: 100%;
	height: 100%;
}

.online_status_btn {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
	cursor: pointer;
}

.online_status_btn.online {
	background-color: #E2F8E0;
}

.online_status_btn.offline {
	background-color: #FFF0E1;
}

.online_status_btn_text {
	font-size: 14px;
}

.online_status_btn.online .online_status_btn_text {
	color: #29C01B;
}

.online_status_btn.offline .online_status_btn_text {
	color: #FEA144;
}

.online_status_btn_icon {
	margin: 0 0 0 2px;
	font-size: 14px;
	color: #9AA0A8;
	visibility: hidden;
}

.online_status_btn:hover .online_status_btn_icon {
	visibility: visible;
}

.list_payOrderStatus {
	margin: 0 24px 0 0;
	font-size: 12px;
	color: #A4AFBA;
}

.order_tag {
	margin: 0 0 0 6px;
	font-size: 12px;
	color: #949CA8;
}

.choosePatient .order_tag {
	color: #FFFFFF;
}
.date-picker{
  padding: 8px 12px;
  border-bottom: 1px solid #EBEAEE;
  .el-date-editor{
    width: 100%;
  }

}
</style>